module.exports = __webpack_public_path__ + "static/media/b&w.cddf685a.jpg";